//
import actionTypes from "shared/profiles/political-committee/political-committee-action-types"
import { resourceGetDetail, resourceGetList, sendAction } from "shared/djangio/action-creators"
import { CANDIDATE_LIMIT, COMMITTEES_REQUEST_LIMIT } from "shared/imports/sharedConstants"

const { PoliticalCommittee } = DjangIO.app.pac.models.political_committee

/**
 * Load all data required for the PoliticalCommittee Profile.
 * This includes the individual PoliticalCommittee with
 * candidate info, the affiliated committees, and the transaction table
 * @name loadPoliticalCommitteeProfile
 * @function
 * @param {Number} id - id of PoliticalCommittee
 */
export const loadPoliticalCommitteeProfile = (id) => async (dispatch, getState) => {
    const politicalCommitteeProfileToJS = getState().politicalCommitteeProfile.toJS()
    if (politicalCommitteeProfileToJS.politicalCommittees && politicalCommitteeProfileToJS.politicalCommittees[id]) {
        const politicalCommitteeInStore = politicalCommitteeProfileToJS.politicalCommittees[id]
        return Promise.resolve(politicalCommitteeInStore)
    } else {
        dispatch(loadFullPoliticalCommittee(id))
    }
    dispatch(loadAffiliatedCommittees(String(id)))
    dispatch(loadJointFundraisingCommittees(String(id)))
    dispatch(loadJointFundraisingRepresentatives(String(id)))
}

/**
 * Load a single Political Committee
 * @name loadFullPoliticalCommittee
 * @function
 * @param {Number} id - id of PoliticalCommittee
 */
export const loadFullPoliticalCommittee = (id) => {
    return resourceGetDetail(PoliticalCommittee.objects, actionTypes.loadPoliticalCommitteeActionDict, id, { id })
}

/**
 * Load all affiliated committees associated with a single PolticalCommittee
 *
 * @name loadAffiliatedCommittees
 * @function
 * @param {Number} id - id of PoliticalCommittee
 */
export const loadAffiliatedCommittees = (id) =>
    resourceGetList(
        PoliticalCommittee,
        actionTypes.loadAffiliatedCommitteeActionDict,
        {
            affiliated_committees_for_committee: id,
            only_fields: ["id", "fec_committee_id", "name", "committee_type"],
            limit: COMMITTEES_REQUEST_LIMIT + 1,
        },
        { id },
    )

/**
 * Load the set of Political Committees that are currently participating with the supplied JFR
 *
 * @name loadJointFundraisingCommittees
 * @function
 * @param {Number} id - id of the JFR
 */
export const loadJointFundraisingCommittees = (id) =>
    resourceGetList(
        PoliticalCommittee,
        actionTypes.loadJointFundraisingCommitteeActionDict,
        {
            get_joint_fundraiser_participants: id,
            only_fields: ["id", "fec_committee_id", "name", "committee_type"],
            limit: COMMITTEES_REQUEST_LIMIT + 1,
        },
        { id },
    )

/**
 * Load the set of Political Committees that are currently participating with the supplied JFR
 *
 * @name loadJointFundraisingRepresentatives
 * @function
 * @param {Number} id - id of the JFR
 */
export const loadJointFundraisingRepresentatives = (id) =>
    resourceGetList(
        PoliticalCommittee,
        actionTypes.loadJointFundraisingRepresentativeActionDict,
        {
            get_joint_fundraiser_representatives: id,
            only_fields: ["id", "fec_committee_id", "name", "committee_type"],
            limit: COMMITTEES_REQUEST_LIMIT + 1,
        },
        { id },
    )

export const loadCommitteeTransactionSummary = (id, ledgerSettingsIds, isCandidateCommittee) =>
    sendAction(DjangIO.app.ledger.models.Transaction, actionTypes.loadCommitteeTransactionSummaryActionDict, {
        action: "transactions_summary",
        method: "get",
        kwargs: {
            committee: [id],
            ledger_settings: ledgerSettingsIds,
            transaction_type: [DjangIO.app.ledger.types.TransactionType.money_given.value],
        },
        payload: {
            id,
        },
    })

export const invalidatePoliticalCommittee = (id) => ({
    type: actionTypes.UPDATE_POLITICAL_COMMITTEE,
    id,
})
